import {Payment} from '@dms/api/sales';

export const isCorrectiveTaxDocument = (payment: Pick<Payment, 'discriminator'>) =>
  payment.discriminator === 'BALANCE_CORRECTION_FULL' ||
  payment.discriminator === 'BALANCE_CORRECTION_PARTIAL';
